import { AppButton, AppFile, AppInput, AppModal, AppTable } from 'components';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from 'services/api';
import { useForm } from 'react-hook-form';

const DoctorPhotos = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [data, setData] = useState([]);
  const [page] = useState(
    searchParams.get('page') ? Number(searchParams.get('page')) : 1
  );
  const titles = ['DOCTOR', 'BAŞLIK', 'FOTOĞRAF'];
  const [doctor, setDoctor] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState();

  const onDelete = async id => {
    api.shared.delete('photo', id).then(() => {
      navigate(0);
    });
  };

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {}
  });

  const onSubmit = async submitData => {
    setIsLoading(true);
    await api.shared
      .create('photo', {
        doctorId: id,
        title: submitData.title,
        image: image
      })
      .then(async () => {
        navigate(0);
      })
      .catch(error => console.log('error', error));
    setIsLoading(false);
  };

  useEffect(() => {
    api.shared
      .listByDoctor('photo', id)
      .then(async res => {
        setData(res.data);
      })
      .catch(error => console.log('error', error));

    api.shared
      .get('doctor', id)
      .then(async res => {
        setDoctor(res.data);
      })
      .catch(error => console.log('error', error));
  }, []);

  return (
    <main className="w-full">
      <AppButton
        className="mb-5 ml-auto"
        isFullWidth={false}
        isAdd={true}
        onClick={() => setIsModalOpen(true)}
      >
        Yeni Fotoğraf Ekle
      </AppButton>
      <AppTable
        titles={titles}
        rows={data}
        isEdit={false}
        isDelete={true}
        pageKey="doctor"
        pageNumber={page}
        onDelete={onDelete}
        isSendArchive={false}
        pageItems={20}
        hideRows="__v,_id,createdAt,updatedAt,isDeleted"
      />
      <AppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className={`text-center text-2xl font-bold mb-4`}>
          Yeni Fotoğraf Ekle
        </div>
        <div className="flex text-sm text-gray-700 mb-2 gap-2">
          Doktor:
          <span className={`font-bold`}>{doctor.name}</span>
        </div>
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            label="Fotoğraf Başlığı"
            name="title"
            // @ts-ignore
            error={errors.title}
            rules={{ required: true }}
            register={register}
            placeholder="Fotoğraf Başlığı"
          />
          <img src={image} className="w-32 h-auto mt-5 bg-gray-300" />
          <AppFile
            error=""
            label="Resim"
            onCompleted={file => setImage(file.cdnUrl)}
            crop="16:9"
          />
          <AppButton type="submit" className="mt-5" isLoading={isLoading}>
            EKLE
          </AppButton>
        </form>
      </AppModal>
    </main>
  );
};

export default DoctorPhotos;
